let cultural = [
    {
        path: 'cultural',
        name: '法律援助',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
          {
            path: 'consulting',
            component: () => import("@/views/admin/life/cultural/consulting/index.vue"),
            name: '法律咨询',
            meta: {
              hidden: true,
              key:14001
            },
          },
          {
            path: 'entrusted',
            component: () => import("@/views/admin/life/cultural/entrusted/index.vue"),
            name: '(案件)委托管理',
            meta: {
              hidden: true,
              key:14002
            },
          },
          {
            path: 'raise',
            component: () => import("@/views/admin/life/cultural/raise/index.vue"),
            name: '众筹打官司',
            meta: {
              hidden: true,
              key:14003
            },
          },
          {
            path: 'consultant',
            component: () => import("@/views/admin/life/cultural/consultant/index.vue"),
            name: '村企顾问',
            meta: {
              hidden: true,
              key:14004
            },
          },
          {
            path: 'lawyers',
            component: () => import("@/views/admin/life/cultural/lawyers/index.vue"),
            name: '律师管理',
            meta: {
              hidden: true,
              key:14005
            },
          },
          {
            path: 'field',
            component: () => import("@/views/admin/life/cultural/field/index.vue"),
            name: '领域标签',
            meta: {
              hidden: true,
              key:14008
            },
          },
          {
            path: 'notary',
            component: () => import("@/views/admin/life/cultural/notary/index.vue"),
            name: '公证管理',
            meta: {
              hidden: true,
              key:14006
            },
          },
          {
            path: 'propaganda',
            component: () => import("@/views/admin/life/cultural/propaganda/index.vue"),
            name: '法律宣传',
            meta: {
              hidden: true,
              key:14007
            },
          },


        ]
    }

]


let legal = [
  {
      path: 'legal',
      name: '文化教育',
      component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
      children: [
        {
          path: 'propaganda',
          component: () => import("@/views/admin/life/legal/propaganda/index.vue"),
          name: '乡村文化宣传管理',
          meta: {
            hidden: true,
            key:15001
          },
        },
        {
          path: 'employment',
          component: () => import("@/views/admin/life/legal/employment/index.vue"),
          name: '大学生乡村就业管理',
          meta: {
            hidden: true,
            key:15002
          },
        },
      ]
  }
]

let spirituallife = [
  {
      path: 'spirituallife',
      name: '生活服务',
      component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
      children: [
        {
          path: 'shop-type',
          component: () => import("@/views/admin/life/spirituallife/shop-type/index.vue"),
          name: '商家分类服务',
          meta: {
            hidden: true,
            key:16006
          },
        },
        {
          path: 'products',
          component: () => import("@/views/admin/life/spirituallife/products/index.vue"),
          name: '小店商品',
          meta: {
            hidden: true,
            key:16008
          },
        },
        {
          path: 'order',
          component: () => import("@/views/admin/life/spirituallife/order/index.vue"),
          name: '小店订单',
          meta: {
            hidden: true,
            key:16007
          },
        },
        {
          path: 'enterprise',
          component: () => import("@/views/admin/life/spirituallife/enterprise/index.vue"),
          name: '服务商家管理',
          meta: {
            hidden: true,
            key:16001
          },
        },
        // {
        //   path: 'other',
        //   component: () => import("@/views/admin/life/spirituallife/other/index.vue"),
        //   name: '其他管理',
        //   meta: {
        //     hidden: true,
        //     key:16002
        //   },
        // },
        // {
        //   path: 'community',
        //   component: () => import("@/views/admin/life/spirituallife/community/index.vue"),
        //   name: '社区共享管理',
        //   meta: {
        //     hidden: true,
        //     key:16003
        //   },
        // },
        {
          path: 'invitation',
          component: () => import("@/views/admin/life/spirituallife/invitation/index.vue"),
          name: '供需管理',
          meta: {
            hidden: true,
            key:16005
          },
        },
        {
          path: 'notary',
          component: () => import("@/views/admin/life/spirituallife/notary/index.vue"),
          name: '便民服务',
          meta: {
            hidden: true,
            key:16009
          },
        },
        // {
        //   path: 'market',
        //   component: () => import("@/views/admin/life/spirituallife/market/index.vue"),
        //   name: '乡村集市管理',
        //   meta: {
        //     hidden: true,
        //     key:16004
        //   },
        // }
      ]
  }
]

let public_good = [
  {
    path: 'public-good',
    name: '公益服务',
    component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
    children: [
      {
        path: 'volunteer',
        component: () => import("@/views/admin/life/public-good/volunteer/index.vue"),
        name: '志愿快讯管理',
        meta: {
          hidden: true,
          key:17001
        },
      },
      {
        path: 'seek-help',
        component: () => import("@/views/admin/life/public-good/seek-help/index.vue"),
        name: '社会求助管理',
        meta: {
          hidden: true,
          key:17002
        },
      },
      {
        path: 'yanglao',
        component: () => import("@/views/admin/life/public-good/yanglao/index.vue"),
        name: '养老服务管理',
        meta: {
          hidden: true,
          key:17003
        },
      },
      {
        path: 'aid',
        component: () => import("@/views/admin/life/public-good/aid/index.vue"),
        name: '公益助学管理',
        meta: {
          hidden: true,
          key:17004
        },
      },

    ]
}


]

let govern = [
  {
      path: 'govern',
      name: '乡村治理',
      component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
      children: [
        {
          path: 'village-affairs',
          component: () => import("@/views/admin/life/govern/village-affairs/index.vue"),
          name: '村务公开',
          meta: {
            hidden: true,
            key:18001
          },
        },
        {
          path: 'mailbox',
          component: () => import("@/views/admin/life/govern/mailbox/index.vue"),
          name: '村民信箱',
          meta: {
            hidden: true,
            key:18002
          },
        }
      ]
  }
]

let agrotechnical = [
  {
      path: 'agrotechnical',
      name: '农技服务',
      component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
      children: [
        {
          path: 'overview',
          component: () => import("@/views/admin/life/agrotechnical/overview/index.vue"),
          name: '农技统计',
          meta: {
            hidden: true,
            key:24007
          },
        },
        {
          path: 'specialist',
          component: () => import("@/views/admin/life/agrotechnical/specialist/index.vue"),
          name: '专家管理',
          meta: {
            hidden: true,
            key:24001
          },
        },
        {
          path: 'specialist-type',
          component: () => import("@/views/admin/life/agrotechnical/specialist-type/index.vue"),
          name: '专家分类',
          meta: {
            hidden: true,
            key:24002
          },
        },
        {
          path: 'inquiry',
          component: () => import("@/views/admin/life/agrotechnical/inquiry/index.vue"),
          name: '咨询管理',
          meta: {
            hidden: true,
            key:24003
          },
        },
        {
          path: 'inquiry-type',
          component: () => import("@/views/admin/life/agrotechnical/inquiry-type/index.vue"),
          name: '咨询分类',
          meta: {
            hidden: true,
            key:24004
          },
        },
        {
          path: 'propaganda',
          component: () => import("@/views/admin/life/agrotechnical/propaganda/index.vue"),
          name: '资料库',
          meta: {
            hidden: true,
            key:24005
          },
        },
        {
          path: 'workorder',
          component: () => import("@/views/admin/life/agrotechnical/workorder/index.vue"),
          name: '现场咨询',
          meta: {
            hidden: true,
            key:24006
          },
        },
      ]
  }
]


let policyadvocacy = [
  {
      path: 'policyadvocacy',
      name: '政策宣传',
      component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
      children: [
        {
          path: 'consultation',
          component: () => import("@/views/admin/life/policyadvocacy/consultation/index.vue"),
          name: '政策宣传',
          meta: {
            hidden: true,
            key:26001
          },
        }
      ]
  }
]

export const life = [
    {
        path: '/life',
        name: '生活服务系统',
        component: () => import("@/views/layout/index.vue"),
        children: [
            ...cultural,//法律援助
            ...legal,///文化教育
            ...spirituallife,//生活服务
            ...public_good,//公益服务
            ...govern,//乡村治理
            ...agrotechnical,//农技服务
            // ...supply,//供电服务
            ...policyadvocacy,//政策宣传
        ]
    },

]
